import { motion } from "framer-motion";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FAQS = [
  {
    q: "What is MockTP?",
    a: "MockTP is a professional student progress management app for driving instructors. Use the Student Progress Dashboard, Students, Reports and Student Packages to keep complete learning records, supported by structured RSA and DVSA assessments.",
  },
  {
    q: "Which assessment systems are supported?",
    a: "MockTP supports Ireland (RSA) and Great Britain (DVSA) assessment systems for mock driving assessments.",
  },
  {
    q: "How much does MockTP cost?",
    a: "MockTP Professional is €3.99/month in Ireland or £3.49/month in Great Britain. It includes a 30-day free trial and is available now on Google Play.",
  },
  {
    q: "When will MockTP be available?",
    a: "MockTP is available now on Google Play. iOS is coming soon.",
  },
  {
    q: "Will my students need the app?",
    a: "No. Students do not need MockTP. Instructors can generate and share professional branded PDF reports featuring their own logo, making it easy to discuss results and progress without requiring students to install the app.",
  },
  {
    q: "Can I use MockTP without an internet connection?",
    a: "Yes. MockTP works without an internet connection. Internet access is only required if you choose to share reports by email or WhatsApp. If you're offline, you can simply send them later when you're connected again.",
  },
  {
    q: "Where is student data stored?",
    a: "Student records are currently stored securely on your own device. Backup and restore tools are included, so you remain in control of your data. Cloud sync and MockTP accounts will be introduced in a future release.",
  },
];

export const FAQ = () => {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="relative overflow-hidden scroll-mt-24"
    >
      <div className="relative max-w-3xl mx-auto px-6 py-24 lg:py-32">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.4 }}
          transition={{ duration: 0.6 }}
          className="text-center flex flex-col gap-5 mb-14"
        >
          <h2
            data-testid="faq-title"
            className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tighter text-white leading-[1.1]"
          >
            Frequently asked questions.
          </h2>
          <p className="text-base md:text-lg text-slate-400 leading-relaxed">
            Straight answers about MockTP, current features and launch availability.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.15 }}
          transition={{ duration: 0.6 }}
        >
          <Accordion type="single" collapsible className="flex flex-col gap-3">
            {FAQS.map((faq, i) => (
              <AccordionItem
                key={i}
                value={`faq-${i}`}
                data-testid={`faq-item-${i}`}
                className="border-0 rounded-2xl border border-white/[0.07] bg-white/[0.03] px-6 data-[state=open]:border-[#00DC82]/30 data-[state=open]:bg-[#00DC82]/[0.04] transition-colors duration-300"
              >
                <AccordionTrigger className="text-base font-medium text-white hover:no-underline py-5 [&>svg]:text-[#00DC82]">
                  {faq.q}
                </AccordionTrigger>
                <AccordionContent className="text-sm text-slate-400 leading-relaxed pb-5 pr-4">
                  {faq.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
};
